import {BASE_SERVICE_URL} from '../lib/constants'

export default function (uid, sheetIndex, eventType, keys, headers, perspective, databaseName, dateReference,skipRealtime) {    

    return fetch(BASE_SERVICE_URL + `/${uid}/${sheetIndex}/save`, {
        credentials: 'same-origin',
        method: 'POST',
        headers: {
            'Accept': 'application/json, text/plain, */*',
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            eventType,
            keys,
            headers,
            perspective,
            databaseName,
            dateReference,
            skipRealtime
        })
    }).then((response) => {
        if (response.ok) {
            return new Promise((resolve, reject) => resolve(response))
        } else {
            const error = new Error(response.statusText)

            error.response = response
            throw error
        }
    })
}
